import React from 'react';
import { Column } from '../../../Layout';
import { Text } from '../../../Text';

export function EmptyList() {
  return (
    <Column size={12} justifyContent="center" padding="3xl">
      <Text fontSize="h2_0" textAlign="center">
        No items found
      </Text>
    </Column>
  );
}
